/**
 * Task library phone list. Categories stay collapsed, with a count.
 * Search matches the title, description, or category.
 */

function libraryCategoryGroups(tasks, query) {
  const needle = String(query || '').trim().toLowerCase();
  const matched = (tasks || []).filter((task) => {
    if (!needle) return true;
    const haystack = `${task.title || ''} ${task.description || ''} ${task.category || ''}`.toLowerCase();
    return haystack.includes(needle);
  });
  const groups = [];
  const index = new Map();
  matched.forEach((task) => {
    const name = String((task && task.category) || 'Other').trim() || 'Other';
    let group = index.get(name);
    if (!group) {
      group = { name, tasks: [] };
      index.set(name, group);
      groups.push(group);
    }
    group.tasks.push(task);
  });
  groups.sort((left, right) => left.name.localeCompare(right.name));
  return groups;
}

module.exports = { libraryCategoryGroups };
